import moment from "moment"

export const settings = {
  title: process.env.REACT_APP_TITLE,
  lead: process.env.REACT_APP_LEAD,
  description: process.env.REACT_APP_DESCRIPTION,
  zone_id: process.env.REACT_APP_ZONE_ID,
  map_zoom: process.env.REACT_APP_MAP_ZOOM,
  root: process.env.REACT_APP_ROOT,
  recomend_key: process.env.REACT_APP_KEYWORD ? process.env.REACT_APP_KEYWORD : "" ,
  max_plan_size: process.env.REACT_APP_MAX_PLAN_SIZE ? process.env.REACT_APP_MAX_PLAN_SIZE : 5,
  detail_search: [
    { label: "露天風呂がある", name: "roten" },
    { label: "露天風呂付き客室", name: "has_roten_buro" },
    { label: "貸切風呂", name: "has_kasikiri_buro" },
    { label: "日帰り入浴", name: "has_oneday" },
    { label: "素泊まり", name: "has_sudomari" },
    { label: "一泊朝食付き", name: "has_morning" },
    { label: "湯治・長期滞在", name: "has_long_stay" },
    { label: "バリアフリー対応", name: "has_barrier_free" },
    { label: "部屋食対応", name: "has_room_meal" },
    { label: "ペット同伴", name: "has_pet" },
    { label: "エステ", name: "has_beauty" },
  ],
  search_default: () => {
    var tommorow = moment().add(1, "day");
    return {
      // stay_date:1, adult_num:2, 
      region_id: 5,
      prefecture_id: 31,
      large_area_id: 1,
      small_area_id: 1,
      checkin_at:{year: tommorow.year(), month: tommorow.month() + 1, date: tommorow.date() }
    };
  },
  fixed_condition: [
    "region_id", "prefecture_id", "large_area_id"
  ]
};